angular.module('TetherApp').factory('quickLinkService', [
    '$http',
    function ($http) {
        let randomString = function randomString(length, chars) {
            let result = '';
            length = length == undefined ? 16 : length;
            chars = chars == undefined
                ? '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                : chars;
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getUserQuickLinks = function (data) {
            return $http.get(
                '/api/v1/quick-link/' + randomString(),
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: data
                }
            ).then(
                function (response) {
                    return response.data;
                }
            );
        };

        let storeQuickLink = function (data) {
            return $http.post(
                '/api/v1/quick-link',
                data,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            ).then(
                function (response) {
                    return response.data;
                }
            );
        };

        let deleteQuickLink = function (quickLinkId, data) {
            return $http.delete(
                '/api/v1/quick-link/' + quickLinkId,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: data
                }
            ).then(
                function (response) {
                    return response.data;
                }
            );
        };

        return {
            getUserQuickLinks: getUserQuickLinks,
            storeQuickLink: storeQuickLink,
            deleteQuickLink: deleteQuickLink
        }

    }
]);
